import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {  Drawer, Radio, Space } from 'antd';
import FilterInput from "components/Form/filterInput"
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { maritalStatusOptions, documentTypeOptions, leaveStatusOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';

const LeaveFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    leaveTypes,
    handleDateChange


}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {
    userData, userDataLoading,
    department, departmentLoading,

    costCenter, costCenterLoading
} = useSelector((state) => state.common);



const [userDataOption, setUserDataOption] = useState([]);


const [departmentOption, setDepartmentOption] = useState([]);


const [costCenterOption, setCostCenterOption] = useState([]);



useEffect(()=>{
   
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    let _departments = department.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })

    let cost_center = costCenter.map(item=> {
        return{
            label: item.code,
            value: item.id
        }
    })
    setUserDataOption(_userData)  


    setDepartmentOption(_departments)

    setCostCenterOption(cost_center)

},[userData, department, costCenter])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);



  return (
    <>
      <Drawer
        title="Filter Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
       <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>

    

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "approval_status")}} optionLabel={"label"} optionValue={'value'} options={leaveStatusOptions} value={setFilterValue("approval_status")} placeholder={"Approval status"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "leave_type")}} optionLabel={"label"} optionValue={'value'} isLoading={false} value={setFilterValue("leave_type")} options={leaveTypes}  placeholder={"Leave type"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'}  options={departmentOption} isLoading={departmentLoading}  value={setFilterValue("department")} placeholder={"Department"}/>
        </div>



        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption}  value={setFilterValue("cost_center")} placeholder={"Cost Center"} isLoading={costCenterLoading}/>
        </div>

      

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>


      </Drawer>
    </>
  );
};
export default LeaveFilterDrawer;